import {
  getDishMasterContract, 
  getTkoCommonStakeERC721EarnERC20Contract,
  getStakeBmoncEarnBmonContract,
  getBakerySoccerMasterContract,
  getPokerCardMasterContract,
  getSoccerPokerGameBoxMasterContract,
  getCarNFTMasterContract,
  getDoggyNFTCommonStakeERC721EarnBakeContract,
  getBarkingNFTCommonStakeERC721EarnBakeContract,
  getDoggyEquipmentCommonStakeERC721EarnBakeContract,
  getMatrixPlusBoxCommonStakeERC721EarnBakeContract,
  getBakeMuskMixerCommonStakeERC721EarnBake2Contract,
  getDoggyEquipmentCommonStakeERC721EarnBake2Contract,
  getPokerCardCommonStakeERC721EarnBake2Contract,
  getBarkingNFTCommonStakeERC721EarnBake2Contract,
  getDoggyNFTCommonStakeERC721EarnBake2Contract,
  getCarNFTCommonStakeERC721EarnBake2Contract,
  getBakerySoccerCommonStakeERC721EarnBake2Contract,
  getComboNFTCommonStakeERC721EarnBake2Contract,
  getBakerySoccerCommonStakeERC721EarnBake3Contract,
  getCarNFTCommonStakeERC721EarnBake3Contract,
  getDoggyNFTCommonStakeERC721EarnBake3Contract,
  getBarkingNFTCommonStakeERC721EarnBake3Contract,
  getDoggyEquipmentCommonStakeERC721EarnBake3Contract,
  getBakeMuskMixerCommonStakeERC721EarnBake3Contract,
  getPokerCardCommonStakeERC721EarnBake3Contract,
  getComboNFTCommonStakeERC721EarnBake3Contract,
} from '../sushi/utils'
import { 
  getBakeMuskMixerCommonStakeERC721EarnBakeContract 
} from '../sushi/bakeMuskMixer'

import { getSimpleStakeToysEarnGatContract } from '../sushi/simpleStakeERC721EarnERC20'

import { NFTTYPE } from '../constants/bakery/nft'
import { MINTTOKEN } from '../constants/bakery'

export function userNFTMasterContract(sushi: any, type?: string) {
  let contract = getDishMasterContract(sushi)
  switch (type) {
    case NFTTYPE.COMBO:
      contract = getDishMasterContract(sushi)
      break
    case NFTTYPE.COMBO_V2:
      contract = getComboNFTCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.COMBO_V3:
      contract = getComboNFTCommonStakeERC721EarnBake3Contract(sushi)
      break
    case MINTTOKEN.TOYNFTSTAKE:
      contract = getSimpleStakeToysEarnGatContract(sushi)
      break
    case MINTTOKEN.TKONFTSTAKE:
      contract = getTkoCommonStakeERC721EarnERC20Contract(sushi)
      break
    case MINTTOKEN.BMONCNFTSTAKE:
      contract = getStakeBmoncEarnBmonContract(sushi)
      break
    case MINTTOKEN.BMMNFTSTAKE:
      contract = getBakeMuskMixerCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.SOCCER:
      contract = getBakerySoccerMasterContract(sushi)
      break
    case NFTTYPE.SOCCER_V2:
      contract = getBakerySoccerCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.SOCCER_V3:
      contract = getBakerySoccerCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.POKER:
      contract = getPokerCardMasterContract(sushi)
      break
    case NFTTYPE.POKER_V2:
      contract = getPokerCardCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.POKER_V3:
      contract = getPokerCardCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.GAMEBOX:
      contract = getSoccerPokerGameBoxMasterContract(sushi)
      break
    case NFTTYPE.CAR:
      contract = getCarNFTMasterContract(sushi)
      break
    case NFTTYPE.CAR_V2:
      contract = getCarNFTCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.CAR_V3:
      contract = getCarNFTCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.DOGGIES:
      contract = getDoggyNFTCommonStakeERC721EarnBakeContract(sushi)
      break
    case NFTTYPE.DOGGIES_V2:
      contract = getDoggyNFTCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.DOGGIES_V3:
      contract = getDoggyNFTCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.BARKING:
      contract = getBarkingNFTCommonStakeERC721EarnBakeContract(sushi)
      break
    case NFTTYPE.BARKING_V2:
      contract = getBarkingNFTCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.BARKING_V3:
      contract = getBarkingNFTCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.EQUIPMENT:
      contract = getDoggyEquipmentCommonStakeERC721EarnBakeContract(sushi)
      break
    case NFTTYPE.EQUIPMENT_V2:
      contract = getDoggyEquipmentCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.EQUIPMENT_V3:
      contract = getDoggyEquipmentCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.MATRIX:
      contract = getMatrixPlusBoxCommonStakeERC721EarnBakeContract(sushi)
      break
    case NFTTYPE.BAKEMUSKMIXER:
      contract = getBakeMuskMixerCommonStakeERC721EarnBakeContract(sushi)
      break
    case NFTTYPE.BAKEMUSKMIXER_V2:
      contract = getBakeMuskMixerCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.BAKEMUSKMIXER_V3:
      contract = getBakeMuskMixerCommonStakeERC721EarnBake3Contract(sushi)
      break
  }
  return contract
}
